import { Alert, Box, Container } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import useApiEp from "../../hooks/useApiEp";
import MuPb from "../../widgets/MuPb";
import { getErrorResponse } from "../../utils/util";
import BackBtn from "../../widgets/BackBtn";
import PageTitle from "../../widgets/PageTitle";
import JsonTextEditor from "./JsonTextEditor";
import { API_ENDPOINT } from "../../utils/constants";

const FlowJsonEditor = () => {
  const { id } = useParams();
  const { data, isLoading, isError, error } = useApiEp(
    `/api/get-flow-asset/${id}`
  );
  if (isLoading) {
    return <MuPb />;
  }
  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }
  return (
    <Container maxWidth="md" sx={{ mt: 3 }}>
      <BackBtn />
      <PageTitle>Flow JSON Editor</PageTitle>
      <Box mt={1}>
        <JsonTextEditor
          initialData={data.json}
          apiEndpoint={`${API_ENDPOINT}/api/update-flow-json/${id}`}
          onSuccess={(response) => {}}
        />
      </Box>
    </Container>
  );
};

export default FlowJsonEditor;
